import React from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './orderDetails.module.scss';

export function SectionHeader({ label }) {
    const { t } = useTranslation();
    return <div className={Styles.SectionHeader}>{t(label)}</div>;
}
